import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicSelect, Loader } from 'core/components';

const CloseOutExitTemplate = ({
	t,
	closeOutExitViewStore: {
		loading,
		form,
		warehouseOptions,
		onWarehouseSelect,
		disableSaveBtn,
		debouncedWarehouseSearch,
		onMenuClose,
		isWarehouseDropdownLoading,
		handleOnWarehouseMenuScroll,
		closeOutExit,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('CLOSEOUTEXITVIEW.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<BaasicSelect
						field={form.$('warehouse')}
						clearable={false}
						options={warehouseOptions.slice()}
						onChange={onWarehouseSelect}
						value={form.$('warehouse').value}
						onMenuScrollToBottom={handleOnWarehouseMenuScroll}
						onInputChange={debouncedWarehouseSearch}
						isLoading={isWarehouseDropdownLoading}
						onBlur={onMenuClose}
						className="spc--bottom--sml flex--grow--1"
					/>
				</div>
				<div className="ReactModal__footer">
					<button
						className="btn btn--med btn--primary spc--bottom--sml"
						type="button"
						onClick={closeOutExit}
						disabled={form.$('warehouse').value === null || disableSaveBtn}
					>
						{t('CONFIRMTHIS')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(CloseOutExitTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/CloseOutExitTemplate.jsx